import React from "react";
import { withFormik } from "formik";

import { Modal } from "../../../../components/modal";
import { ValidatedForm } from "../../../../components";
import { type PackRequest } from "../types/state";
import validationSchemas from "../../../../utils/validationSchemas";
import { type PackRequestModalProps, type PackRequestModalWithFormProps } from "./types";
import RequestPackForm from "./RequestPackForm";
import RequestPackModalActions from "./RequestPackModalActions";
import ModalSizes from "../../../../enums/modalSizes";

import "./packRequestModal.scss";

export const PackRequestModal: React.FC<PackRequestModalWithFormProps> = (props) => {
  const { values, isValid, resetForm, onCancelPackRequest, onSubmitPackRequest } = props;

  const renderModalActions = (closeModal: any) => {
    return (
      <RequestPackModalActions
        onSubmit={() => {
          onSubmitPackRequest?.(values);
          closeModal();
        }}
        onCancel={() => {
          closePackRequestModal();
          closeModal();
        }}
        isValid={isValid}
        submitText="Request Pack"
      />
    );
  };

  const closePackRequestModal = () => {
    resetForm();
    onCancelPackRequest?.();
  };

  return (
    <Modal
      className={"pack-request-modal"}
      title="Request Pack"
      open={props.isOpen}
      renderModalActions={renderModalActions}
      onCancel={closePackRequestModal}
      size={ModalSizes.tiny}
      dataTestId="request-pack-modal"
    >
      <ValidatedForm formWidthComputer={16} formWidthTablet={16} {...props}>
        <RequestPackForm {...props} />
      </ValidatedForm>
    </Modal>
  );
};

/* istanbul ignore next */
const ConnectedComponent = withFormik<PackRequestModalProps, PackRequest>({
  validateOnMount: true,
  validationSchema: validationSchemas.packRequestValidationSchema,
  mapPropsToValues: (props: PackRequestModalProps) => {
    return {
      packId: props.packId,
    } as PackRequest;
  },
  handleSubmit: () => {}, // NOSONAR
  enableReinitialize: true,
})(PackRequestModal);

export default ConnectedComponent;
